import { useRef, useEffect, useState } from "react";
import Pagination from "../../../../Components/Pagination";
import Button from "../../../../Core/Button/Button";
import GetIcon from "../../../../utils/Icon";

const TableTab1 = ({ selected_default_item_attribulte_data }) => {
const { value: rows = [], setValue } = selected_default_item_attribulte_data;

  const tableRef = useRef();
  const [rowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRows, setSelectedRows] = useState([]);
  const [focusedCell, setFocusedCell] = useState({ rowIndex: null, field: null });

  const isAllSelected = rows.length > 0 && selectedRows.length === rows.length;
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = rows.slice(indexOfFirstRow, indexOfLastRow);


const createNewRow = () => ({
  attribute_value: "",
  abbr: "",
});

useEffect(() => {
  if (rows.length === 0) {
    setValue([createNewRow()]);
    setFocusedCell({ rowIndex: 0, field: "attribute_value" });
  }
}, [rows]);




  const updateRow = (index, field, value) => {
    const updatedRows = rows.map((row, i) =>
      i === index ? { ...row, [field]: value } : row
    );
    setValue(updatedRows); // ✅ store in pageState
  };


const toggleRowSelection = (index) => {
  setSelectedRows((prev) =>
    prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
  );
};



  const handleAddRow = () => {
    const newRows = [...rows, createNewRow()];
    setValue(newRows);
    const lastPage = Math.ceil(newRows.length / rowsPerPage);
    if (currentPage !== lastPage) setCurrentPage(lastPage);
  };

  const handleDeleteSelectedRows = () => {
    const updatedRows = rows.filter((_, idx) => !selectedRows.includes(idx));
    setValue(updatedRows);
    setSelectedRows([]);
    const lastPage = Math.ceil(updatedRows.length / rowsPerPage);
    if (currentPage > lastPage) setCurrentPage(lastPage);
  };

  // resizable header
  useEffect(() => {
    const cols = tableRef.current?.querySelectorAll("th");
    cols?.forEach((col) => {
      const resizer = document.createElement("div");
      resizer.className = "resizer";
      col.appendChild(resizer);

      let x = 0;
      let w = 0;

      const onMouseDown = (e) => {
        x = e.clientX;
        w = col.offsetWidth;
        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
      };

      const onMouseMove = (e) => {
        const dx = e.clientX - x;
        col.style.width = `${w + dx}px`;
      };

      const onMouseUp = () => {
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
      };

      resizer.addEventListener("mousedown", onMouseDown);
    });
  }, []);

  return (
    <div>
      <table className="table table-bordered mb-1" ref={tableRef}>
        <thead className="tableHead1">
          <tr>
            {[
              "Action",
              "S.No",
              "Attribute Value",
              "Abbreviation",
              <GetIcon iconName="PiSlidersHorizontalBold" size={12} />,
            ].map((title, i) => {
              const isIcon = typeof title !== "string";
              const defaultWidths = {
                Action: "54px",
                "S.No": "54px",
                "Attribute Value": "303px",
                "Abbreviation": "303px",
              };

              return (
                <th
                  key={i}
                  style={{
                    fontSize: "7px",
                    position: "relative",
                    textAlign: "center",
                    width: isIcon ? "303px" : defaultWidths[title] || "303px",
                    minWidth: isIcon ? "303px" : defaultWidths[title] || "303px",
                  }}
                >
                  {title === "Action" ? (
                    <input
                      type="checkbox"
                      className="form-check-input"
                      style={{
                        backgroundColor: isAllSelected ? "#270b79" : "",
                        borderColor: isAllSelected ? "#270b79" : "",
                        fontSize: "15px",
                      }}
                      checked={isAllSelected}
                      onChange={(e) =>
                        e.target.checked
                          ? setSelectedRows(rows.map((_, idx) => idx))
                          : setSelectedRows([])
                      }
                    />
                  ) : isIcon ? (
                    <div className="d-flex justify-content-center align-items-center">
                      {title}
                    </div>
                  ) : (
                    title
                  )}
                </th>
              );
            })}
          </tr>
        </thead>

        <tbody>
          {currentRows.map((row, index) => {
            const globalIndex = indexOfFirstRow + index;
            return (
              <tr key={globalIndex}>
                <td className="p-0 text-center">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    style={{
                      backgroundColor: selectedRows.includes(globalIndex) ? "#270b79" : "",
                      borderColor: selectedRows.includes(globalIndex) ? "#270b79" : "",
                    }}
                    checked={selectedRows.includes(globalIndex)}
  onChange={() => toggleRowSelection(globalIndex)}
                  />
                </td>



                <td className="text-center" style={{ fontSize: "0.8rem" }}>
                  {globalIndex + 1}
                </td>

                <td className="p-0 d-flex justify-content-center">
                  <input
                    type="text"
                    className="form-control tableinput noborder"
                    style={{
                      fontSize: "0.8rem",
                      textAlign: "center",
                      border:
                        focusedCell.rowIndex === globalIndex &&
                          focusedCell.field === "attribute_value"
                          ? "0.3px solid #270b79"
                          : "",
                    }}
                    value={row.attribute_value || ""}
                    placeholder="Attribute Value"
                    onFocus={() => { }}
                    onBlur={() => { }}
                    onChange={(e) =>
                      updateRow(globalIndex, "attribute_value", e.target.value)
                    }
                  />
                </td>

                <td className="p-0">
                  <input
                    type="text"
                    className="form-control tableinput noborder"
                    style={{
                      fontSize: "0.8rem",
                      textAlign: "center",
                      border:
                        focusedCell.rowIndex === globalIndex &&
                          focusedCell.field === "abbr"
                          ? "0.3px solid #270b79"
                          : "",
                    }}
                    value={row.abbr || ""}
                    placeholder="Abbreviation"
                    onFocus={() =>
                      setFocusedCell({ rowIndex: globalIndex, field: "abbr" })
                    }
                    onBlur={() => setFocusedCell({ rowIndex: null, field: null })}
                    onChange={(e) =>
                      updateRow(globalIndex, "abbr", e.target.value)
                    }
                  />
                </td>

                <td style={{ position: "relative", width: "40px" }}>
                  <img
                    src="/Maskgroup.png"
                    alt="edit"
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      width: "12px",
                      height: "12px",
                      pointerEvents: "none",
                    }}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <div className="d-flex pb-2 justify-content-between align-items-center">
        <div className="d-flex" style={{ gap: "4px" }}>
          <Button
            onClick={handleAddRow}
            className="Addrowdesign"
            iconName="FiPlus"
            iconSize={12}
            iconWrapperStyle={{
              backgroundColor: "#F6D593",
              padding: "1px",
              display: "flex",
            }}
          >
            Add Row
          </Button>

          {selectedRows.length > 0 && (
            <Button
              onClick={handleDeleteSelectedRows}
              className="customdeletebtn"
              iconName="MdDeleteOutline"
              iconSize={12}
            >
              Delete
            </Button>
          )}
        </div>


        <div
          className={`${rows.length < 11 ? "d-none" : "d-flex"
            } align-items-center centerpagination`}
          style={{ gap: "5px" }}
        >
          <Pagination
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            pageSize={rowsPerPage}
            totalrecords={rows.length}
          />
        </div>

        <div className={`${rows.length < 11 ? "d-none" : "d-flex"}`}>
          <span className="px-2" style={{ fontSize: "12px", color: "#270B79" }}>
            Showing {indexOfFirstRow + 1} to{" "}
            {Math.min(indexOfLastRow, rows.length)} of {rows.length} entries
          </span>
        </div>
      </div>
    </div>
  );
};

export default TableTab1;
